const WHATSAPP = 'https://wa.me/917306725502';
const EMAIL = 'mailto:info@globesynctravel.com';
const INSTAGRAM =
  'https://www.instagram.com/globesync_travel?stkn=YnhxZGZtMGUxZHox';
const FACEBOOK = 'https://www.facebook.com/share/1LSHkL3wre/';
const LOGO =
  'https://public.readdy.ai/ai/img_res/92fe985b-bf86-46bc-98fa-34f8209cf877.png';
const FUTURUM_LOGO =
  'https://storage.helloreaddy.io/project_files/72bb2555-7c62-4243-8368-e35694228ca3/1a0bac21-64f0-4a3f-abf0-08251d2e0a2b_compressed_Logo-Round.webp';

const QUICK_LINKS = [
  ['#services', 'Tour Packages'],
  ['#services', 'Flights'],
  ['#services', 'Hotels'],
  ['#services', 'Visas'],
];

export default function Footer() {
  return (
    <footer className="relative w-full bg-primary-950 pt-16 text-background-50 md:pt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* About */}
          <div className="lg:col-span-2">
            <a
              href="#top"
              className="inline-flex items-center rounded-2xl bg-background-50 px-5 py-4"
              aria-label="GlobeSync Travel home"
            >
              <img
                src={LOGO}
                alt="GlobeSync Travel Agency Logo Ernakulam"
                title="GlobeSync Travel — Syncing You with the World"
                className="h-28 w-auto max-w-[70vw] object-contain md:h-32 md:max-w-none"
              />
            </a>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-100/75">
              GlobeSync Travel is a premium travel agency built to make global
              journeys effortless. From curated tour packages, worldwide flight
              bookings and premium hotel reservations to end-to-end visa
              assistance, our team handles every detail — across every time zone,
              all year round.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.16em] text-background-100">
              Quick Links
            </h4>
            <ul className="mt-5 space-y-3">
              {QUICK_LINKS.map(([href, label]) => (
                <li key={label}>
                  <a href={href} className="gs-link text-sm text-background-100/75 hover:text-background-50">
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#why" className="gs-link text-sm text-background-100/75 hover:text-background-50">
                  Why GlobeSync
                </a>
              </li>
              <li>
                <a href="#contact" className="gs-link text-sm text-background-100/75 hover:text-background-50">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Connect + Contact */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.16em] text-background-100">
              Connect with Us
            </h4>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={FACEBOOK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GlobeSync Travel on Facebook"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a
                href={INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GlobeSync Travel on Instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href={EMAIL}
                aria-label="Email GlobeSync Travel"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-mail-line text-lg" />
              </a>
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Message GlobeSync Travel on WhatsApp"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
            </div>

            <ul className="mt-6 space-y-3 text-sm text-background-100/75">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 shrink-0 text-accent-400" />
                <span>
                  Suite No: 769, 2nd Floor, KC Arcade, Near TV Center, CSEZ P O,
                  Kakkanad, Ernakulam – 682037
                </span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line shrink-0 text-accent-400" />
                <a href={EMAIL} className="gs-link hover:text-background-50">
                  info@globesynctravel.com
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-whatsapp-line shrink-0 text-accent-400" />
                <a href={WHATSAPP} className="gs-link hover:text-background-50" target="_blank" rel="noopener noreferrer">
                  {`+91 7306725502`}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-12 border-t border-background-50/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-center text-xs text-background-100/60 sm:flex-row md:px-6">
          <p className="nowrap">© 2026 GlobeSync Travel | globesynctravel.com | All Rights Reserved.</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-earth-line" />
            Global travel support, wherever you go
          </p>
        </div>
      </div>

      {/* Digital Brand Partner sub-footer */}
      <div className="border-t border-background-50/10 bg-primary-950">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-3 px-4 py-6 text-center sm:flex-row sm:gap-4 md:px-6">
          <span className="text-xs font-medium tracking-wide text-background-100/45 sm:text-sm">
            Digital Brand Partner:
            <span className="ml-1 font-semibold text-background-100/70">Futurum Works</span>
          </span>
          <img
            src={FUTURUM_LOGO}
            alt="Futurum Works Digital Marketing logo - Digital Brand Partner of GlobeSync Travel"
            title="Futurum Works — Digital Brand Partner"
            className="h-8 w-8 rounded-full object-cover opacity-80 grayscale transition-opacity hover:opacity-100 hover:grayscale-0 sm:h-9 sm:w-9"
          />
        </div>
      </div>
    </footer>
  );
}